import { useState } from 'react'
import './InputIncrementDecrement.scss'

const InputIncrementDecrement = ({ initialValue = 0 }) => {
  const [value, setValue] = useState(initialValue)

  return (
    <div className="input-value">
      <div className="input-value_button source-16 bold c-white" onClick={() => setValue(prevValue => prevValue <=0 ? 0 : prevValue - 1)}>-</div>
      <div className="input-value_value source-16 sm-bold">{value}</div>
      <div className="input-value_button source-16 bold c-white" onClick={() => setValue(prevValue => prevValue + 1)}>+</div>
    </div>
  )
}

export default InputIncrementDecrement
